import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconQuestionMark16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconQuestionMark16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.485 5.106C5.752 4.054 6.845 3 8.158 3c.719 0 1.288.167 1.675.519.378.343.667.938.667 1.981 0 .727-.527 1.205-1.32 1.866l-.062.051C8.419 8 7.5 8.763 7.5 10a.5.5 0 0 0 1 0c0-.727.527-1.205 1.32-1.866l.062-.051C10.582 7.5 11.5 6.737 11.5 5.5c0-1.228-.345-2.133-.995-2.722C9.865 2.198 9.012 2 8.158 2 6.325 2 4.879 3.43 4.516 4.86a.5.5 0 1 0 .969.246M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconQuestionMark16);
